import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * GA4 SPA page-view tracker.
 *
 * GA4's default `gtag('config', 'G-...')` snippet fires one `page_view`
 * on initial load. Since this app uses React Router for client-side
 * navigation, subsequent route changes do NOT trigger new `page_view`
 * events unless we explicitly send them.
 *
 * Render this component once, inside <BrowserRouter>. On every location
 * change it pushes a `page_view` with the new `page_path`, `page_title`,
 * and full `page_location` URL.
 *
 * Silent no-op if `gtag` isn't loaded (dev without tag, blocked by
 * ad-blockers, etc.).
 */
export default function GA4RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}
